import React, { ReactNode, useRef, useState } from 'react';
import ReactToPrint from 'react-to-print';

import {
  Modal,
  Backdrop,
  Fade,
  Button,
  Container,
  Typography,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Divider,
} from '@material-ui/core/';
import { useSelector } from 'react-redux';
import { useStyles } from './styles';

import { IState } from '../../store';
import { IChart } from '../../store/modules/chart/types';
import HeatMapChart from '../HeatMapChart';
import LineChart from '../LineChart';
import BarChart from '../BarChart';
import TableChart from '../TableChart';

import HeatMap from '../../assets/heatmap.svg';
import BarChartVerticalIcon from '../../assets/barChartVertical.svg';
import BarChartHorizontalIcon from '../../assets/barChartHorizontal.svg';
import LineChartIcon from '../../assets/lineChart.svg';
import TableIcon from '../../assets/table.svg';
import Error from '../../assets/remove.svg';

interface ChartName {
  array: String[];
}

const Export: React.FC = () => {
  const componentRef: any = useRef();
  const [openMissingDetails, setMissingDetails] = React.useState(false);

  const classes = useStyles();
  const charts = useSelector<IState, IChart[]>((state) => state.chart.charts);
  const [generate, setGenerate] = useState(false);
  const [selectedCharts, setSelectedCharts] = useState<IChart[]>([]);
  const [chartName, setChartName] = useState<ChartName>({ array: [] });

  const handleCloseMissingDetails = () => {
    setMissingDetails(false);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const arr = event.target.name;
    setChartName({ array: [...chartName.array, arr] });
  };

  const generateCharts = () => {
    if (chartName.array.length === 0) {
      setMissingDetails(true);
    } else {
      const chartRender: IChart[] = charts.filter((pos) => {
        const include = chartName.array.includes(pos.name);
        if (!include) {
          return null;
        }
        return pos;
      });
      setSelectedCharts(chartRender);
      setGenerate(true);
    }
  };

  const printDocument = () => {
    const paper = document.getElementById('paperCharts');
    if (paper) {
      paper.style.display = 'none';
    }
  };

  const renderCharts = (arr: IChart[]): ReactNode => {
    return arr.map((c) => {
      switch (c.chartType.toLowerCase()) {
        case 'heat': {
          return (
            <>
              <Typography variant="h6" className={classes.typo}>
                {c.name}
              </Typography>

              <Container className={classes.containerHeatChart}>
                {c.heat ? <HeatMapChart dataHeatMap={c.heat} /> : <></>}
              </Container>
            </>
          );
        }
        case 'line': {
          return (
            <>
              <Typography variant="h6" className={classes.typo}>
                {c.name}
              </Typography>

              <Container className={classes.containerChart}>
                {c.chart ? (
                  <LineChart
                    data={c.chart}
                    legendOne={c.legendOne}
                    legendTwo={c.legendTwo}
                    legendY={c.legendY}
                    lineTwo
                  />
                ) : (
                  <></>
                )}
              </Container>
            </>
          );
        }
        case 'barv': {
          return (
            <>
              <Typography variant="h6" className={classes.typo}>
                {c.name}
              </Typography>

              <Container className={classes.containerChart}>
                {c.chart ? (
                  <BarChart
                    data={c.chart}
                    legendOne={c.legendOne}
                    legendTwo={c.legendTwo}
                    legendY={c.legendY}
                    percent={c.percent}
                  />
                ) : (
                  <></>
                )}
              </Container>
            </>
          );
        }
        case 'barh': {
          return (
            <>
              <Typography variant="h6" className={classes.typo}>
                {c.name}
              </Typography>

              <Container className={classes.containerChart}>
                {c.chart ? (
                  <BarChart
                    data={c.chart}
                    legendOne={c.legendOne}
                    legendTwo={c.legendTwo}
                    direction
                    legendY={c.legendY}
                    percent={c.percent}
                  />
                ) : (
                  <></>
                )}
              </Container>
            </>
          );
        }
        case 'table': {
          return (
            <>
              <Typography variant="h6" className={classes.typo}>
                {c.name}
              </Typography>

              <Container className={classes.containerChart}>
                {c.table ? <TableChart data={c.table} /> : <></>}
              </Container>
            </>
          );
        }
        case 'multiline': {
          return (
            <>
              <Typography variant="h6" className={classes.typo}>
                {c.name}
              </Typography>

              <Container className={classes.containerChart}>
                {c.multi ? (
                  c.multi.map((cc) => {
                    return (
                      <>
                        <Typography variant="subtitle1" className={classes.typo}>
                          {cc.value}
                        </Typography>
                        <LineChart
                          data={cc.results}
                          legendOne={c.legendOne}
                          legendTwo={c.legendTwo}
                          legendY={c.legendY}
                          lineTwo
                        />
                      </>
                    );
                  })
                ) : (
                  <></>
                )}
              </Container>
            </>
          );
        }

        default: {
          return <></>;
        }
      }
    });
  };

  return (
    <>
      <Container className={classes.paperRoot}>
        <div className={classes.paper} id="paperCharts">
          <Container className={classes.exportChart}>
            {generate ? (
              <></>
            ) : (
              <>
                <Typography variant="h6" className={classes.typoTitle}>
                  Escolha os gráficos
                </Typography>
              </>
            )}
            <Container className={classes.selectGroup}>
              {generate ? (
                <></>
              ) : (
                <>
                  <FormControl id="selectgraficos">
                    <FormGroup>
                      {charts.map((item: IChart) => (
                        <>
                          <FormControlLabel
                            control={
                              <>
                                <Checkbox
                                  key={item.name}
                                  color="primary"
                                  onChange={handleChange}
                                  name={item.name}
                                />
                              </>
                            }
                            label={
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                {item.img === 'HeatMap' && (
                                  <img
                                    src={HeatMap}
                                    alt={item.name}
                                    className={classes.imgSelect}
                                  />
                                )}
                                {item.img === 'BarChartHorizontalIcon' && (
                                  <img
                                    src={BarChartHorizontalIcon}
                                    alt={item.name}
                                    className={classes.imgSelect}
                                  />
                                )}
                                {item.img === 'BarChartVerticalIcon' && (
                                  <img
                                    src={BarChartVerticalIcon}
                                    alt={item.name}
                                    className={classes.imgSelect}
                                  />
                                )}
                                {item.img === 'LineChartIcon' && (
                                  <img
                                    src={LineChartIcon}
                                    alt={item.name}
                                    className={classes.imgSelect}
                                  />
                                )}
                                {item.img === 'TableIcon' && (
                                  <img
                                    src={TableIcon}
                                    alt={item.name}
                                    className={classes.imgSelect}
                                  />
                                )}
                                <p className={classes.itemName}>{item.name}</p>
                              </div>
                            }
                          />
                        </>
                      ))}
                    </FormGroup>
                  </FormControl>
                </>
              )}
            </Container>

            {generate ? (
              <ReactToPrint
                trigger={() => {
                  return (
                    <Button
                      variant="text"
                      className={classes.buttonToPDF}
                      onClick={() => printDocument()}
                    >
                      gerar pdf
                    </Button>
                  );
                }}
                content={() => componentRef.current}
              />
            ) : (
              <Button
                variant="text"
                className={classes.buttonExport}
                onClick={() => generateCharts()}
              >
                gerar gráficos
              </Button>
            )}
          </Container>
        </div>
      </Container>

      <Container style={{ display: 'flex', flexFlow: 'column', alignItems: 'center' }}>
        <Container className={classes.root}>
          <div id="exported" ref={componentRef}>
            <div id="header" className={classes.header}>
              <Typography
                variant="subtitle2"
                style={{ color: '#7E7E7D', marginTop: '3%' }}
              >
                INFORMAÇÃO PARA GESTÃO DA SEGURANÇA NO TRÂNSITO
              </Typography>
              <Typography variant="h5" style={{ margin: '3% 0 5% 0' }}>
                Plataforma VIDA
              </Typography>
              <Divider style={{ margin: '3% 0 5% 0', width: '100%' }} />
            </div>
            {renderCharts(selectedCharts)}
          </div>
        </Container>
      </Container>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openMissingDetails}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openMissingDetails}>
          <div className={classes.paperModal}>
            <img src={Error} alt="Selecione gráficos para exportar." width="50" />
            <p id="transition-modal-description">Selecione gráficos para exportar.</p>
            <Button
              className={classes.button}
              onClick={() => handleCloseMissingDetails()}
            >
              Ok
            </Button>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default Export;
